import React from 'react';
import 'components/info-banner/InfoBanner.scss';

interface InfoBannerProps {
  children: React.ReactNode;
}

const InfoBanner: React.FC<InfoBannerProps> = ({ children }) => {
  return (
    <div className="hk-info-banner-container">
      <div className="hk-info-banner">{children}</div>
    </div>
  );
};

export default InfoBanner;
